/*
 * Hydrates images that ship with their real URLs in data-src / data-srcset.
 *
 * Why this exists: loading="lazy" is not a budget. On a throttled connection Chrome
 * still fetches every image within ~3000px of the viewport, so the homepage was pulling
 * 170-245 images at once and starving the hero image of bandwidth (LCP 18s). Cards below
 * the fold now carry a 1x1 placeholder and are hydrated only once they approach the
 * viewport, which makes "load what the customer can see" deterministic instead of
 * dependent on a browser heuristic.
 *
 * Hover images are hydrated only on devices that can actually hover, so touch devices
 * never pay for them.
 */
(function () {
  var MAIN = 'img.card__img--deferred';
  var HOVER = 'img.card__img--deferred-hover';
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function hydrate(img) {
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    if (srcset) img.setAttribute('srcset', srcset);
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.classList.remove('card__img--deferred');
    img.classList.remove('card__img--deferred-hover');
  }

  // No IntersectionObserver (very old browser): hydrate everything rather than show blanks.
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(MAIN + ',' + HOVER).forEach(hydrate);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var img = entry.target;
        observer.unobserve(img);
        hydrate(img);

        // Bring the matching hover image in with its card, but only where hover exists.
        if (canHover) {
          var card = img.closest('.card__picture') || img.parentNode;
          if (card) {
            var hover = card.querySelector(HOVER);
            if (hover) hydrate(hover);
          }
        }
      });
    },
    // Start fetching shortly before the card scrolls in so it is rarely visibly empty.
    { rootMargin: '400px 0px' }
  );

  function scan(root) {
    var scope = root || document;
    scope.querySelectorAll(MAIN).forEach(function (img) {
      observer.observe(img);
    });
    // Above-the-fold cards keep a real src on the main image, so it is never
    // deferred and never hydrates its hover sibling. Watch hover images directly
    // as well, or those cards show a broken image on hover. Touch devices skip
    // this entirely and keep the bandwidth saving.
    if (canHover) {
      scope.querySelectorAll(HOVER).forEach(function (img) {
        observer.observe(img);
      });
    }
  }

  scan(document);

  // Cards also arrive from AJAX pagination, filters and quick-view, so watch for new ones.
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(MAIN)) observer.observe(node);
          else if (canHover && node.matches && node.matches(HOVER)) observer.observe(node);
          else scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  // Escape hatch for other scripts that inject cards imperatively.
  window.hydrateDeferredImages = scan;
})();
